import forEach from 'lodash/forEach';

import { caseLogicMsg } from '../validationMessages';

function validateMigratedNodes(caseConf, nodeInfo) {
  const errors = [];
  const warnings = [];

  // Checks
  nodeInfo.checkNodes.forEach((node) => {
    forEach(node.data, (check) => {
      // Migration warning
      if (check.fromInfusionMigration) {
        warnings.push(
          caseLogicMsg('Check adjusted, please verify that it is functioning as intended', node.id, {
            migrationWarning: {
              details: 'Check adjusted, please verify that it is functioning as intended',
              link: 'https://vimeo.com/853393518/f72c070c0a'
            }
          })
        );
      }
    });
  });

  // Timers
  for (const timerNode of nodeInfo.timerNodes) {
    if (timerNode.data.fromInfusionMigration) {
      warnings.push(
        caseLogicMsg('This timer was added to preserve functionality', timerNode.id, {
          migrationWarning: {
            details: 'This timer was added to preserve functionality',
            link: 'https://vimeo.com/853393518/f72c070c0a'
          }
        })
      );
    }
  }

  return {
    errors,
    warnings,
  };
}

export default validateMigratedNodes;
